/**
 * @file Chooses the Orders tab's amount column and its title from the granted
 * level of an answer. Consumer: `analyticsOrderLines`. My sales and My team read the credited share,
 * `orderedAmount`, as "Credited value"; Org reads the whole line amount,
 * `lineOrderedAmount`, as "Line value". The level is the answer's granted
 * one, never the requested scope.
 */
import type { AnalyticsScopeLevel } from '#types';

import type { AnalyticsOrderAmount } from './analyticsOrdersTab.types';

export const analyticsOrderAmount = (
  level: AnalyticsScopeLevel,
): AnalyticsOrderAmount =>
  level === 'org'
    ? { column: 'lineOrderedAmount', title: 'Line value' }
    : { column: 'orderedAmount', title: 'Credited value' };
